import type { Theme } from '@emotion/react'
import { css } from '@emotion/react'
import {
  breakpoint,
  pxToRem,
  size,
  width,
} from '@twistopayments/design-system/styles'

export const wrap = css`
  margin: auto;
  padding: ${size[16]};
  width: fit-content;
  max-width: ${width.container.wider};
`

export const title = css`
  text-align: center;
  font-weight: 700;
  font-size: ${pxToRem(24)};
  margin-bottom: ${size[40]};

  ${breakpoint.up('smMd')} {
    font-size: ${pxToRem(36)};
  }
`

export const subtitle = (theme: Theme) => css`
  color: ${theme.palette.primary.mainContrast};
  font-weight: 700;
  font-size: ${pxToRem(16)};
  margin-bottom: ${size[12]};
  text-align: center;
`

export const list = css`
  padding: 0;
  margin: 0;
  line-height: 1.2rem;
`

export const profile = css`
  display: flex;
  gap: ${size[40]};
  margin-bottom: ${size[60]};
  align-items: center;
  flex-direction: column;

  ${breakpoint.up('smMd')} {
    flex-direction: row;
    margin-bottom: ${size[48]};

    &:nth-of-type(even) {
      flex-direction: row-reverse;
    }
  }

  ${breakpoint.up('md')} {
    gap: ${size[128]};
  }
`

export const photo = css`
  width: 360px;
  height: 360px;
  overflow: hidden;
  border-radius: 10px 30px 10px 30px;
  flex-shrink: 0;
  object-fit: cover;
`

export const info = css`
  margin: 0 ${size[32]};

  ${breakpoint.up('smMd')} {
    margin: 0;
  }
`

export const position = (theme: Theme) => css`
  color: ${theme.palette.primary.mainContrast};
  font-weight: 700;
  font-size: ${pxToRem(24)};
  margin-bottom: ${size[12]};
`

export const name = (theme: Theme) => css`
  color: ${theme.palette.primary.mainContrast};
  font-weight: 700;
  font-size: ${pxToRem(24)};
  margin-bottom: ${size[18]};

  ${breakpoint.up('smMd')} {
    margin-bottom: ${size[28]};
    font-size: ${pxToRem(36)};
  }
`

export const desc = css`
  font-weight: 400;
  font-size: ${pxToRem(18)};
  line-height: ${pxToRem(24)};
`
